import React from 'react';
import { Typography } from './Typography';
import { MoonIcon, SunIcon, BrainIcon } from 'lucide-react';
import { t } from '../src/locales';
export const BenefitsSection = () => {
  const benefits = t('benefits.items');
  const benefitIcons = [<MoonIcon size={48} className="text-[#004FFF]" data-id="element-9" />, <SunIcon size={48} className="text-[#004FFF]" data-id="element-10" />, <BrainIcon size={48} className="text-[#004FFF]" data-id="element-11" />];
  return <section id="benefits" className="w-full bg-white py-20 px-6 md:px-12" data-id="element-12">
      <div className="max-w-6xl mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-[50px] leading-[56px] text-[#192636] font-[200] mb-4" data-id="element-15">
            {t('benefits.title')}
          </h2>
          <Typography variant="medium" className="text-[#192636] max-w-2xl mx-auto" data-id="element-16">
            {t('benefits.description')}
          </Typography>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-17">
          {benefits.map((benefit, index) => <div key={index} className="bg-[#EBE6DC] p-8 rounded-xl flex flex-col items-center text-center" data-id="element-18">
              <div className="mb-6" data-id="element-19">{benefitIcons[index]}</div>
              <Typography variant="large" as="h3" className="text-[#192636] mb-4 font-[200]" data-id="element-20">
                {benefit.title}
              </Typography>
              <Typography variant="small" className="text-[#192636]" data-id="element-21">
                {benefit.description}
              </Typography>
            </div>)}
        </div>
      </div>
    </section>;
};